import { Shield, Mail } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function PrivacyPolicy() {
  const { t, lang } = useLanguage();
  usePageMeta("privacy");
  const blocks = t("privacy.blocks");
  const locale = lang === "en" ? "en-CA" : "fr-CA";

  return (
    <div className="animate-fade-up bg-white">
      <section className="py-20 sm:py-28 lg:py-40 bg-slate-50 border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="w-14 h-14 rounded-2xl bg-blue-50 text-blue-600 grid place-items-center">
            <Shield className="w-7 h-7" strokeWidth={2} />
          </div>
          <div className="text-xs tracking-[0.3em] uppercase font-display font-semibold text-blue-600 mt-6">{t("privacy.eyebrow")}</div>
          <h1 data-testid="privacy-title" className="font-heading text-5xl lg:text-6xl font-normal tracking-tight leading-[1.15] text-slate-900 mt-3 leading-[1.05]">
            {t("privacy.title")}
          </h1>
          <p className="mt-6 text-slate-600 leading-relaxed">
            {t("privacy.updated")}{new Date().toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric" })}
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 space-y-10 text-slate-700 leading-relaxed">
          {blocks.map((b) => (
            <Block key={b.title} title={b.title}>
              {b.body.map((p, i) => (
                <p key={i} className={i > 0 ? "mt-3" : ""}>{p}</p>
              ))}
            </Block>
          ))}
          <Block title={lang === "en" ? "Contact" : "Nous joindre"}>
            <div className="mt-4 p-5 rounded-2xl bg-slate-50 border border-slate-200">
              <div className="font-medium text-slate-900">Reflectum Pellicule</div>
              <a href="mailto:contact@reflectumpellicule.com" className="mt-2 inline-flex items-center gap-2 text-blue-600 hover:text-blue-700">
                <Mail className="w-4 h-4" /> contact@reflectumpellicule.com
              </a>
              <div className="mt-1 text-sm text-slate-600">{t("contact.info.areaValue")}, Québec, Canada</div>
              <a href="tel:+14382556438" className="mt-1 block text-sm text-slate-600 hover:text-blue-600">438 255 6438</a>
            </div>
          </Block>
        </div>
      </section>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-heading text-2xl lg:text-3xl font-normal text-slate-900 mb-4">{title}</h2>
      <div className="space-y-2">{children}</div>
    </div>
  );
}
